export enum BasketballFoulAttribute {
  Offensive = 505,
  Technical = 506,
  Unsportsmanlike = 507,
}
